import { Component, OnInit } from '@angular/core';
import { FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';
import { ReducerUtilityService } from '../../../../../shared/utility-services/reducer-utility.service';
import { MedigapMedicationsStateStructure } from '../../../../../shared/reducers/medigap-medications.reducer';

@FormComponentLookup('health-check-medication-review')
@Component({
    selector: 'app-health-check-medication-review',
    templateUrl: './health-check-medication-review.component.html',
    styleUrls: ['./health-check-medication-review.component.scss'],
    standalone: false
})
export class HealthCheckMedicationReviewComponent extends FormEntryComponentClass {

  isPrescribedMedsRawValue: string;
  isPrescribedMeds: boolean = false;
  medFormMedications = [];

  constructor(
    private reducerUtilService: ReducerUtilityService
  ) { 
    super();
  }

  ngOnInit(): void {
    const currentState = this.reducerUtilService.getPayloadState<MedigapMedicationsStateStructure>('MedigapEnrollmentMedications');
    this.isPrescribedMedsRawValue = currentState?.medicationForm?.isPrescribedMeds;

    // default value to true to show meds when this question does not exist
    this.isPrescribedMeds = this.isPrescribedMedsRawValue ? this.isPrescribedMedsRawValue.toLowerCase() === "yes" : true;

    // filter out fully blank rows
    this.medFormMedications = currentState?.medicationForm?.medications?.filter((med) => med.medicationName || med.medicationDosage || med.currentlyTaking || med.conditionForMed);
  }

}
